import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Settings,
  AnnualLeaveSetting,
  SpecialLeaveSetting,
  SickLeaveSetting,
  ScheduleSetting,
  DetailScheduleSetting,
  AddScheduleSetting,
  EditScheduleSetting,
  AddShift,
  EditShift,
  ApprovalSetting,
  DetailApprovalSetting,
  AddApprovalSetting,
  EditApprovalSetting,
  Company,
  CompanyInfo,
  OrganitationalStructure,
  DetailOrganitationalStructure,
  AddOrganitationalStructure,
  EditOrganitationalStructure,
  JobLevel,
  DetailJobLevel,
  AddJobLevel,
  DeleteJobLevel,
  Position,
  DetailPosition,
  AddPosition,
  EditPosition,
  CompanyPolicy,
  DetailCompanyPolicy,
  AddCompanyPolicy,
  CalendarSetting,
  DetailCalendarSetting,
  AddCalendarSetting,
  PayrollSetting,
  MainPayroll,
  AddPayrollSalarySlip,
  EditPayrollSalarySlip,
  AddIncomeComponent,
  AddCutComponent,
  DetailIncomeComponents,
  DetailCutComponents,
  EditIncomeComponent,
  EditCutComponent,
  SortPayrollComponents,
  ImplementationSalarySlip,
  Thr,
  LeaveAllowance,
  UnpaidLeave,
  OvertimePay,
  ProRate,
  TaxPayroll,
  BpjsPayroll,
  HistoryBpjsEmployement,
  HistoryBpjsHealthcare,
  CompanyAccount,
  GradingPayroll,
  RoundingPayroll,
  SeverancesPayroll,
  MobileMenu,
  Users,
  Roles,
  AddRoles,
  EditRoles,
  BusinessFlow,
  Setup,
  SetupSuccess,
  AccountMapping,
  SettingTemplate,
  SettingAuditLog,
  SettingOpenApi,
  SettingAddOpenApi,
  SettingDetailOpenApi,
  SettingCashReceipt,
  SettingReimbursement,
  SettingImportPlafonCashReceipt,
  SelectShift,
  SettingImportPlafonReimbursement,
  SettingTracking,
  AttendanceValidationSetting,
  AttendanceValidationPresenceSetting,
  AttendanceValidationOvertimeSetting,
  AttendanceValidationClientVisitSetting,
  AttendanceLocations,
  AddAttendanceLocations,
  EditAttendanceLocations,
  Billing,
  UpgradeBilling,
  UpgradeEmployeeBilling,
  AddAddonBilling,
  SettingOvertime,
  AddSettingOvertime,
  DetailSettingOvertime,
  EditSettingOvertime,
  SSO,
  AddDomainSSO,
  VerifyDomainSSO,
  VerificationSuccessDomainSSO,
  Fingerprint,
  Numbers,
  ImportMultiplierBpjs,
  LayoutSalarySlip,
  Profile,
  EmailTemplate,
  MobileAppsTemplate,
  Translations,
  SelectDeviceFingerprint,
  EditFingerprint,
  AddFingerprint,
  SynchronizationFingerprint,
  HistoryFingerprint,
  SettingTask,
  SettingPayrollTask,
  SettingClientVisitTask,
  SettingPaymentConnect,
  DetailSettingPaymentConnect,
  MainSettingPettyCash,
  PettyCashSettings,
  AddPettyCashSettings,
  EditPettyCashSettings,
  PettyCashCategories,
  AddPettyCashCategories,
  EditPettyCashCategories,
  SuccessBilling,
  FailedBilling,
  SettingReimbursementPlafon,
  SettingReimbursementCategory,
  AddSettingReimbursementCategory,
  EditSettingReimbursementCategory,
  Notification,
} from "./pages";

const settingRoutes = [
  {
    path: "/settings",
    element: (
      <ProtectedRoute name="setting">
        <Settings />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.settings"} />,
  },
  {
    path: "/settings/annual-leave",
    element: (
      <ProtectedRoute name="setting_annual_leave">
        <AnnualLeaveSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="annual_leave" />,
  },
  {
    path: "/settings/special-leave",
    element: (
      <ProtectedRoute name="setting_special_leave">
        <SpecialLeaveSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="special_leave" />,
  },
  {
    path: "/settings/sick-leave",
    element: (
      <ProtectedRoute name="setting_sick_leave">
        <SickLeaveSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="sick_leave"
        defaultTitle="leave.sick_leave"
      />
    ),
  },
  {
    path: "/settings/schedule",
    element: (
      <ProtectedRoute name="setting_schedule">
        <ScheduleSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="schedule" />,
  },
  {
    path: "/settings/schedule/detail/:id",
    element: (
      <ProtectedRoute name="setting_schedule">
        <DetailScheduleSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"schedule.detail_schedule"} />
    ),
  },
  {
    path: "/settings/schedule/add",
    element: (
      <ProtectedRoute name="setting_schedule_add">
        <AddScheduleSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"schedule.add_schedule"} />,
    children: [
      {
        path: "/settings/schedule/add/select",
        element: <SelectShift />,
        breadcrumb: null,
        children: [
          {
            path: "/settings/schedule/add/select/add-shift",
            element: <AddShift />,
            breadcrumb: null,
          },
          {
            path: "/settings/schedule/add/select/shift/:idShift",
            element: <EditShift />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/settings/schedule/edit/:id",
    element: (
      <ProtectedRoute name="setting_schedule_edit">
        <EditScheduleSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"schedule.edit_schedule"} />,
    children: [
      {
        path: "/settings/schedule/edit/:id/select",
        element: <SelectShift />,
        breadcrumb: null,
        children: [
          {
            path: "/settings/schedule/edit/:id/select/add-shift",
            element: <AddShift />,
            breadcrumb: null,
          },
          {
            path: "/settings/schedule/edit/:id/select/shift/:idShift",
            element: <EditShift />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/settings/approval-rule",
    element: (
      <ProtectedRoute name="setting_approval_rule">
        <ApprovalSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="approval_rule" />,
  },
  {
    path: "/settings/approval-rule/detail/:id",
    element: (
      <ProtectedRoute name="setting_approval_rule">
        <DetailApprovalSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="approval.detail" />,
  },
  {
    path: "/settings/approval-rule/add",
    element: (
      <ProtectedRoute name="setting_approval_rule_add">
        <AddApprovalSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"approval.add_rule_approval"} />
    ),
  },
  {
    path: "/settings/approval-rule/edit/:id",
    element: (
      <ProtectedRoute name="setting_approval_rule_edit">
        <EditApprovalSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"approval.edit_approval_title"} />
    ),
  },
  {
    path: "/settings/company",
    element: (
      <ProtectedRoute name="setting_company">
        <Company />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="company" />,
    children: [
      {
        index: true,
        element: (
          <Navigate to="/settings/company/company-info?active_key=1" replace />
        ),
      },
      {
        path: "/settings/company/company-info",
        element: (
          <ProtectedRoute name="setting_company_info">
            <CompanyInfo />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"company.company_info"} />
        ),
      },
      {
        path: "/settings/company/organitation-structure",
        element: (
          <ProtectedRoute name="setting_company_org_structure">
            <OrganitationalStructure />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"company.organizational_structure"} />
        ),
        children: [
          {
            path: "/settings/company/organitation-structure/detail/:id",
            element: <DetailOrganitationalStructure />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/organitation-structure/add",
            element: <AddOrganitationalStructure />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/organitation-structure/edit/:id",
            element: <EditOrganitationalStructure />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/settings/company/job-title",
        element: (
          <ProtectedRoute name="setting_company_job_level">
            <JobLevel />
          </ProtectedRoute>
        ),
        breadcrumb: () => <TranslationBreadcrumb name={"company.job_title"} />,
        children: [
          {
            path: "/settings/company/job-title/add",
            element: <AddJobLevel />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/job-title/delete",
            element: <DeleteJobLevel />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/job-title/detail/:id",
            element: <DetailJobLevel />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/settings/company/position",
        element: (
          <ProtectedRoute name="setting_company_job_position">
            <Position />
          </ProtectedRoute>
        ),
        breadcrumb: () => <TranslationBreadcrumb name={"company.position"} />,
        children: [
          {
            path: "/settings/company/position/detail/:id",
            element: <DetailPosition />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/position/add",
            element: <AddPosition />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/position/edit/:id",
            element: <EditPosition />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/settings/company/company-policy",
        element: (
          <ProtectedRoute name="setting_company_policy">
            <CompanyPolicy />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"company.company_policy"} />
        ),
        children: [
          {
            path: "/settings/company/company-policy/add",
            element: <AddCompanyPolicy />,
            breadcrumb: null,
          },
          {
            path: "/settings/company/company-policy/detail/:id",
            element: <DetailCompanyPolicy />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/settings/calendar",
    element: (
      <ProtectedRoute name="setting_calendar">
        <CalendarSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="calendar" />,
    children: [
      {
        path: "/settings/calendar/add",
        element: <AddCalendarSetting />,
        breadcrumb: null,
      },
      {
        path: "/settings/calendar/detail/:id",
        element: <DetailCalendarSetting />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/settings/payroll",
    element: (
      <ProtectedRoute name="setting_payroll">
        <PayrollSetting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="payroll" />,
    children: [
      {
        index: true,
        element: (
          <Navigate to="/settings/payroll/salary-slip?active_key=2" replace />
        ),
      },
      {
        path: "/settings/payroll/salary-slip",
        element: <MainPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name="payroll.salary_slip" />,
      },
      {
        path: "/settings/payroll/salary-slip/add",
        element: <AddPayrollSalarySlip />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="payroll.add_salary_slip" />
        ),
        children: [
          {
            path: "/settings/payroll/salary-slip/add/add-income",
            element: <AddIncomeComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/add/add-cut",
            element: <AddCutComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/add/income/:idComponent",
            element: <DetailIncomeComponents />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/add/income/:idComponent/edit-component",
            element: <EditIncomeComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/add/cut/:idComponent",
            element: <DetailCutComponents />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/add/cut/:idComponent/edit-component",
            element: <EditCutComponent />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/settings/payroll/salary-slip/edit/:id",
        element: <EditPayrollSalarySlip />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="payroll.edit_salary_slip" />
        ),
        children: [
          {
            path: "/settings/payroll/salary-slip/edit/:id/add-income",
            element: <AddIncomeComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/add-cut",
            element: <AddCutComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/income/:idComponent",
            element: <DetailIncomeComponents />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/income/:idComponent/edit-component",
            element: <EditIncomeComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/cut/:idComponent",
            element: <DetailCutComponents />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/cut/:idComponent/edit-component",
            element: <EditCutComponent />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/sort",
            element: <SortPayrollComponents />,
            breadcrumb: null,
          },
          {
            path: "/settings/payroll/salary-slip/edit/:id/implementation",
            element: <ImplementationSalarySlip />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/settings/payroll/thr",
        element: <Thr />,
        breadcrumb: () => <TranslationBreadcrumb name={"thr.title"} />,
      },
      {
        path: "/settings/payroll/leaveAllowance",
        element: <LeaveAllowance />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"leaveAllowance.title"} />
        ),
      },
      {
        path: "/settings/payroll/unpaidLeave",
        element: <UnpaidLeave />,
        breadcrumb: () => <TranslationBreadcrumb name={"unpaidLeave.title"} />,
      },
      {
        path: "/settings/payroll/overtimePay",
        element: <OvertimePay />,
        breadcrumb: () => <TranslationBreadcrumb name={"overtimePay.title"} />,
      },
      {
        path: "/settings/payroll/proRate",
        element: <ProRate />,
        breadcrumb: () => <TranslationBreadcrumb name={"proRate.title"} />,
      },
      {
        path: "/settings/payroll/tax",
        element: <TaxPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name={"tax.title"} />,
      },
      {
        path: "/settings/payroll/bpjs",
        element: <BpjsPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name={"bpjs.title"} />,
      },
      {
        path: "/settings/payroll/bpjs/history-bpjs-employement",
        element: <HistoryBpjsEmployement />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"bpjs.history_bpjs_of_employement"} />
        ),
      },
      {
        path: "/settings/payroll/bpjs/history-bpjs-healthcare",
        element: <HistoryBpjsHealthcare />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"bpjs.history_bpjs_healthcare"} />
        ),
      },
      {
        path: "/settings/payroll/companyAccount",
        element: <CompanyAccount />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"companyAccount.title"} />
        ),
      },
      {
        path: "/settings/payroll/grading",
        element: <GradingPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name="grading" />,
      },
      {
        path: "/settings/payroll/rounding",
        element: <RoundingPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name={"rounding.title"} />,
      },
      {
        path: "/settings/payroll/severances",
        element: <SeverancesPayroll />,
        breadcrumb: () => <TranslationBreadcrumb name={"severancePay.title"} />,
      },
    ],
  },
  {
    path: "/settings/payroll/bpjs/import-bpjs-multiplier",
    element: (
      <ProtectedRoute name="setting_payroll_add">
        <ImportMultiplierBpjs />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"bpjs.import_bpjs_multiplier_per_employee"}
      />
    ),
  },
  {
    path: "/settings/profile",
    element: (
      <ProtectedRoute name="setting_profile">
        <Profile />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="profile" />,
  },
  {
    path: "/settings/roles",
    element: (
      <ProtectedRoute name="setting_roles">
        <Roles />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="roles" />,
  },
  {
    path: "/settings/roles/add",
    element: (
      <ProtectedRoute name="setting_roles_add">
        <AddRoles />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"roles.add_role"} />,
  },
  {
    path: "/settings/roles/edit/:id",
    element: (
      <ProtectedRoute name="setting_roles_edit">
        <EditRoles />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"roles.edit_role"} />,
  },
  {
    path: "/settings/notification",
    element: (
      <ProtectedRoute name="">
        <Notification />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="notification.title" />,
  },
  {
    path: "/settings/users",
    element: (
      <ProtectedRoute name="setting_users">
        <Users />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="users" />,
  },
  {
    path: "/settings/business-flow",
    element: (
      <ProtectedRoute name="businessflow">
        <BusinessFlow />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="businessflow" />,
  },
  {
    path: "/settings/setup",
    element: (
      <ProtectedRoute name="setting">
        <Setup />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="setup" />,
  },
  {
    path: "/settings/setup/success",
    element: (
      <ProtectedRoute name="setting">
        <SetupSuccess />
      </ProtectedRoute>
    ),
    breadcrumb: null,
  },
  {
    path: "/settings/account-mapping",
    element: (
      <ProtectedRoute name="setting_account_mapping">
        <AccountMapping />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="account_mapping"
        defaultTitle="accountMapping.account_mapping"
      />
    ),
  },
  {
    path: "/settings/mobile-menu",
    element: (
      <ProtectedRoute name="mobile_menu">
        <MobileMenu />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="mobile_menu"
        defaultTitle="mobileMenu.application_menu"
      />
    ),
  },
  {
    path: "/settings/attendance",
    element: (
      <ProtectedRoute name="setting_attendance_validation">
        <AttendanceValidationSetting />
      </ProtectedRoute>
    ),
    breadcrumb: null,
    children: [
      {
        path: "/settings/attendance/presence",
        element: <AttendanceValidationPresenceSetting />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="attendance.presence_app_validation" />
        ),
      },
      {
        path: "/settings/attendance/overtime",
        element: <AttendanceValidationOvertimeSetting />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="attendance.presence_app_validation" />
        ),
      },
      {
        path: "/settings/attendance/client-visit",
        element: <AttendanceValidationClientVisitSetting />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="attendance.presence_app_validation" />
        ),
      },
    ],
  },
  {
    path: "/settings/attendance-location",
    element: (
      <ProtectedRoute name="setting_attendance_location">
        <AttendanceLocations />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="attendance_location"
        defaultTitle="attendanceLocation.office_location"
      />
    ),
  },
  {
    path: "/settings/attendance-location/add",
    element: (
      <ProtectedRoute name="setting_attendance_location_add">
        <AddAttendanceLocations />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="attendanceLocation.add_office_location" />
    ),
  },
  {
    path: "/settings/attendance-location/edit/:id",
    element: (
      <ProtectedRoute name="setting_attendance_location_edit">
        <EditAttendanceLocations />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="attendanceLocation.edit_office_location" />
    ),
  },
  {
    path: "/settings/billing",
    element: (
      <ProtectedRoute name="setting_billing">
        <Billing />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="billing" defaultTitle="billing.title" />
    ),
  },
  {
    path: "/settings/billing/upgrade",
    element: (
      <ProtectedRoute name="setting_billing_add">
        <UpgradeBilling />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="billing.upgrade" />,
  },
  {
    path: "/settings/billing/upgrade-employee",
    element: (
      <ProtectedRoute name="setting_billing_add">
        <UpgradeEmployeeBilling />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="employee.add_employee" />,
  },
  {
    path: "/settings/billing/addon",
    element: (
      <ProtectedRoute name="setting_billing_add">
        <AddAddonBilling />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="billing.add_addon" />,
  },
  {
    path: "/settings/template",
    element: (
      <ProtectedRoute name="setting_template">
        <SettingTemplate />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_template"
        defaultTitle="template.notification_templates"
      />
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate to="/settings/template/email?active_key=6" replace />
        ),
      },
      {
        path: "/settings/template/email",
        element: <EmailTemplate />,
        breadcrumb: () => <TranslationBreadcrumb name="template.email" />,
      },
      // {
      //   path: "/settings/template/whatsapp",
      //   element: (
      //
      //       <WhatsappTemplate />
      //
      //   ),
      //   breadcrumb: () => (
      //     <TranslationBreadcrumb name="template.whatsapp" />
      //   ),
      // },
      {
        path: "/settings/template/mobile-apps",
        element: <MobileAppsTemplate />,
        breadcrumb: () => <TranslationBreadcrumb name="template.mobile_apps" />,
      },
    ],
  },
  {
    path: "/settings/layout",
    element: (
      <ProtectedRoute name="setting_layout">
        <LayoutSalarySlip />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_layout"
        defaultTitle="layoutSalarySlip.title"
      />
    ),
  },
  {
    path: "/settings/apps",
    element: (
      <ProtectedRoute name="apps">
        <SettingOpenApi />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="apps" defaultTitle="appSetting.apps" />
    ),
  },
  {
    path: "/settings/apps/add",
    element: (
      <ProtectedRoute name="apps_add">
        <SettingAddOpenApi />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="appSetting.add_apps" />,
  },
  {
    path: "/settings/apps/detail/:id",
    element: (
      <ProtectedRoute name="apps">
        <SettingDetailOpenApi />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="appSetting.detail_apps" />,
  },
  {
    path: "/settings/audit",
    element: (
      <ProtectedRoute name="setting_audit">
        <SettingAuditLog />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="setting_audit" defaultTitle="audit.title" />
    ),
  },
  {
    path: "/settings/cash-receipt",
    element: (
      <ProtectedRoute name="setting_cash_receipt">
        <SettingCashReceipt />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="cash_receipt"
        defaultTitle="cashReceipt.title"
      />
    ),
  },
  {
    path: "/settings/reimbursement",
    element: (
      <ProtectedRoute name="setting_reimbursement">
        <SettingReimbursement />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="reimbursement"
        defaultTitle="reimbursement.title"
      />
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate to="/settings/reimbursement/plafon?active_key=2" replace />
        ),
      },
      {
        path: "/settings/reimbursement/plafon",
        element: <SettingReimbursementPlafon />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="reimbursement.reimbursement_plafon" />
        ),
      },
      {
        path: "/settings/reimbursement/category",
        element: <SettingReimbursementCategory />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="reimbursement.reimbursement_category" />
        ),
        children: [
          {
            path: "/settings/reimbursement/category/add",
            element: <AddSettingReimbursementCategory />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="reimbursement.add_category" />
            ),
          },
          {
            path: "/settings/reimbursement/category/edit/:id",
            element: <EditSettingReimbursementCategory />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="reimbursement.edit_category" />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/settings/cash-receipt/import",
    element: (
      <ProtectedRoute name="setting_cash_receipt_add">
        <SettingImportPlafonCashReceipt />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="cashReceipt.import_cash_receipt_plafon" />
    ),
  },
  {
    path: "/settings/reimbursement/import",
    element: (
      <ProtectedRoute name="setting_reimbursement_add">
        <SettingImportPlafonReimbursement />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="reimbursement.import_reimbursement_plafon" />
    ),
  },
  {
    path: "/settings/location-tracking-rule",
    element: (
      <ProtectedRoute name="setting_location_tracking_rule">
        <SettingTracking />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="location_tracking_rule"
        defaultTitle="tracking.title"
      />
    ),
  },
  {
    path: "/settings/overtime",
    element: (
      <ProtectedRoute name="setting_overtime">
        <SettingOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_overtime"
        defaultTitle="settingOvertime.setting_overtime"
      />
    ),
  },
  {
    path: "/settings/overtime/add",
    element: (
      <ProtectedRoute name="setting_overtime_add">
        <AddSettingOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="settingOvertime.add_setting_overtime" />
    ),
  },
  {
    path: "/settings/overtime/detail/:id",
    element: (
      <ProtectedRoute name="setting_overtime">
        <DetailSettingOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="settingOvertime.detail_setting_overtime" />
    ),
  },
  {
    path: "/settings/overtime/edit/:id",
    element: (
      <ProtectedRoute name="setting_overtime_edit">
        <EditSettingOvertime />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="settingOvertime.edit_setting_overtime" />
    ),
  },
  {
    path: "/settings/automatic-sequencing",
    element: (
      <ProtectedRoute name="setting_automatic_sequencing">
        <Numbers />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_automatic_sequencing"
        defaultTitle="automaticSequencing.title"
      />
    ),
  },
  {
    path: "/settings/fingerprint-connect",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <Fingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_fingerprint_connect"
        defaultTitle="fingerprint.fingerprint_connect"
      />
    ),
  },
  {
    path: "/settings/sso",
    element: <SSO />,
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="sso_setting"
        defaultTitle="sso.sso_setting"
      />
    ),
    children: [
      {
        path: "/settings/sso/add",
        element: <AddDomainSSO />,
        breadcrumb: () => <TranslationBreadcrumb name="sso.add_domain" />,
      },
      {
        path: "/settings/sso/verify",
        element: <VerifyDomainSSO />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="sso.domain_verification" />
        ),
      },
      {
        path: "/settings/sso/success-verify",
        element: <VerificationSuccessDomainSSO />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="sso.verification_success" />
        ),
      },
    ],
  },
  {
    path: "/settings/translation",
    element: (
      <ProtectedRoute name="setting_translation">
        <Translations />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="translation.title" />,
  },
  {
    path: "/settings/fingerprint-connect/select-device",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <SelectDeviceFingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="fingerprint.select_device" />
    ),
  },
  {
    path: "/settings/fingerprint-connect/add",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <AddFingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="fingerprint.add_fingerprint_connect" />
    ),
  },
  {
    path: "/settings/fingerprint-connect/edit/:id",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <EditFingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="fingerprint.edit_fingerprint_connect" />
    ),
  },
  {
    path: "/settings/fingerprint-connect/synchronization/:id",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <SynchronizationFingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="fingerprint.fingerprint_connect_synchronization" />
    ),
  },
  {
    path: "/settings/fingerprint-connect/history",
    element: (
      <ProtectedRoute name="setting_fingerprint_connect">
        <HistoryFingerprint />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="fingerprint.fingerprint_attendance_history" />
    ),
  },
  {
    path: "/settings/task",
    element: (
      <ProtectedRoute name="setting_task">
        <SettingTask />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="setting_task" defaultTitle="task.title" />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/settings/task/payroll?active_key=8" replace />,
      },
      {
        path: "/settings/task/payroll",
        breadcrumb: () => <TranslationBreadcrumb name="payroll.payroll" />,
        element: <SettingPayrollTask />,
      },
      {
        path: "/settings/task/client-visit",
        breadcrumb: () => (
          <TranslationBreadcrumb name="attendance.client_visit" />
        ),
        element: <SettingClientVisitTask />,
      },
    ],
  },
  {
    path: "/settings/payment-connect",
    element: (
      <ProtectedRoute name="setting_payment_connect">
        <SettingPaymentConnect />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="setting_payment_connect"
        defaultTitle="paymentConnect.title"
      />
    ),
  },
  {
    path: "/settings/payment-connect/:id",
    element: (
      <ProtectedRoute name="setting_payment_connect_edit">
        <DetailSettingPaymentConnect />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="paymentConnect.detail" />,
  },
  {
    path: "/settings/petty-cash",
    element: (
      <ProtectedRoute name="setting_petty_cash">
        <MainSettingPettyCash />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="pettyCash.petty_cash" />,
    children: [
      {
        index: true,
        element: (
          <Navigate to="/settings/petty-cash/settings?active_key=2" replace />
        ),
      },
      {
        path: "/settings/petty-cash/settings",
        element: <PettyCashSettings />,
        breadcrumb: null,
        children: [
          {
            path: "/settings/petty-cash/settings/add",
            element: <AddPettyCashSettings />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="pettyCash.add_setting" />
            ),
          },
          {
            path: "/settings/petty-cash/settings/edit/:id",
            element: <EditPettyCashSettings />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="pettyCash.edit_setting" />
            ),
          },
        ],
      },
      {
        path: "/settings/petty-cash/categories",
        element: <PettyCashCategories />,
        breadcrumb: null,
        children: [
          {
            path: "/settings/petty-cash/categories/add",
            element: <AddPettyCashCategories />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="pettyCash.add_category" />
            ),
          },
          {
            path: "/settings/petty-cash/categories/edit/:id",
            element: <EditPettyCashCategories />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="pettyCash.edit_category" />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "/user/billing/success",
    element: <SuccessBilling />,
    breadcrumb: null,
  },
  {
    path: "/user/billing/failed",
    element: <FailedBilling />,
    breadcrumb: null,
  },
];

export default settingRoutes;
